const NEW_YORK_TIME_ZONE = 'America/New_York'

/** Festival deadlines use New York civil time, independent of the visitor. */
export function formatApplicationDeadline(deadline: Date): string {
  const date = new Intl.DateTimeFormat('en-US', {
    timeZone: NEW_YORK_TIME_ZONE,
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  }).format(deadline)
  const time = new Intl.DateTimeFormat('en-US', {
    timeZone: NEW_YORK_TIME_ZONE,
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
  }).format(deadline)
  return `${date} at ${time} (New York time)`
}
